<template>
    <div class="main">
        <section id="brn-post" class="diagonal">
            <BorderDecoration class="top-left" style="left: -10%" :primary="'var(--color-secondary)'" :secondary="'var(--color-gray-light)'"/>
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 intro">
                        <a :href="getPageSlugByLayout('blog')" class="text-uppercase text-primary mb-3">
                            <i class="bi bi-arrow-left-short"></i> All posts
                        </a>
                        <h6 class="text-uppercase text-wide-5 text-secondary">{{ post.created_at | filterTime }}</h6>
                        <ChalkDecoration>
                            <h1>{{ post.title }}</h1>
                        </ChalkDecoration>
                    </div>
                    <div class="col-xl-6 media">
                        <img :src="post.image ? post.image : '/assets/images/backgrounds/tour-default-1.jpg'" :alt="post.title">
                    </div>
                </div>
                <div class="row my-5">
                    <p v-html="post.content"></p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import SettingsMixin from "../../mixins/SettingsMixin";
import ContentMixin from "../../mixins/ContentMixin";
export default {
    name: "Post",
    mixins: [SettingsMixin, ContentMixin],
    components: {ChalkDecoration, BorderDecoration},
    props: {
        post: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
